module.exports = __webpack_public_path__ + "img/user.f91d7385.svg";